<template>
    <v-dialog value="true" width="700" persistent>
        <v-card>
            <v-card-title class="title primary white--text" primary-title>
                Confirmar cancelamento do {{ $tc("pt_br.documento").toLowerCase() }}?
            </v-card-title>
            <v-form v-model="form" ref="form">
                <v-textarea
                    label="Informe o motivo do cancelamento"
                    class="ma-4"
                    counter="240"
                    v-model="cancelarContrato.motivoCancelamento"
                    :rules="[rules.required]"
                    v-validate="'max:240'"
                    data-vv-as="motivoCancelamento"
                    name="motivoCancelamento"
                    type="text"
                    :error-messages="errors.collect('Motivo do cancelamento')"
                />
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="red lighten-3" text @click="fecharModalMotivoCancelamento">
                        CANCELAR
                    </v-btn>
                    <v-btn color="green white--text" :disabled="!form" depressed text
                           @click="confirmarCancelamento">
                        CONFIRMAR
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'modal-motivo-cancelamento',
    data() {
        return {
            rules: {
                required: v => !!v || 'Campo Motivo do cancelamento é obrigatório',
            },
            form: false,
            cancelarContrato: {
                motivoCancelamento: ''
            }
        }
    },
    methods: {
        async confirmarCancelamento() {
            const valido = await this.$validator._base.validateAll()
            if (valido) {
                this.$emit('confirmarCancelamento', this.cancelarContrato)
            }
        },
        fecharModalMotivoCancelamento() {
            this.$emit('fecharModalMotivoCancelamento')
        }
    }
}
</script>